import { Box, Flex, Image, Grid, GridItem } from '@chakra-ui/react';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import WorkspaceMenu from './workspace-menu';
import NavigationMenu from './navigation-menu';
import UserMenu from './user-menu';
import { useAuth } from '@/lib/hooks/use-auth';
import useWorkspace from '@/lib/hooks/use-workspace';

export default function Navigation() {
  const { workspaceId } = useParams();
  const { workspace } = useWorkspace();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <Box as='header' position='sticky' top={0} zIndex={11} bg='secondary.500'>
      <Box mx='auto' width={{ md: '90%' }} maxW='6xl' pt={{ base: 0, md: 4 }}>
        <Flex
          bg='white'
          borderWidth='1px'
          borderColor='gray.200'
          borderRadius={{ base: 0, md: 'xl' }}
          shadow='sm'
          px={{ base: 4, md: 6 }}
          py={2}
          align='center'
          justify='space-between'
        >
          <Box mr={2}>
            {workspace && (
              <NavLink to={`/${workspaceId}/home`}>
                <Box display={{ base: 'none', xl: 'block' }}>
                  <Image
                    src={workspace?.logo || '/logo_horizontal.png'}
                    alt={workspace?.name || 'Coach Hub'}
                    height={'32px'}
                    fit='contain'
                  />
                </Box>
                <Box display={{ base: 'block', xl: 'none' }}>
                  <Image
                    src={workspace?.logo || '/logo.png'}
                    alt={workspace?.name || 'Coach Hub'}
                    h={6}
                  />
                </Box>
              </NavLink>
            )}
          </Box>
          <Grid templateColumns={{ lg: 'auto 1fr auto' }} py={2} w={'full'}>
            <GridItem gridRow={1} gridColumn={1}>
              <WorkspaceMenu currentWorkspaceId={workspaceId} />
            </GridItem>
            <GridItem
              gridRow={1}
              gridColumn={2}
              display={'flex'}
              gridColumnStart={{ lg: 1 }}
              gridColumnEnd={{ lg: -1 }}
              justifyContent={{ lg: 'center' }}
            >
              <Flex justifyContent='center'>
                <NavigationMenu />
              </Flex>
            </GridItem>
            <GridItem gridRow={1} gridColumn={3}>
              <UserMenu workspaceId={workspaceId} handleLogout={handleLogout} />
            </GridItem>
          </Grid>
        </Flex>
      </Box>
    </Box>
  );
}
